import {
  CRANE_EMBED,
  DEV,
  DEV_FEATURES,
  EMBED_WITH_PATH,
  ENRICHMENT_PROGRESS,
  ENRICHMENT_STANDALONE,
  ERROR_BASE,
  ERROR_NOT_FOUND,
  FLASHCARD_DECK,
  READER_WITH_LOCATION,
  TEST,
} from "./route";
import ErrorMain from "../apps/errors/ErrorMain";
import React from "react";
import { makeLazyLoader } from "../common/ui/lazy-load";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { isLocalDev } from "../common/utils/env";

const loader = makeLazyLoader();

const ReaderMain = loader.lazy(() => import("../apps/reader/main/ReaderMain"));
const DevMain = loader.lazy(() => import("../apps/dev/DevMain"));
const FeaturesMain = loader.lazy(() => import("../apps/dev/FeaturesMain"));
const EmbedMain = loader.lazy(() => import("../apps/embed/EmbedMain"));
const EnrichmentMain = loader.lazy(() =>
  import("../apps/enrichment/EnrichmentMain")
);
const FlashcardsMain = loader.lazy(() =>
  import("../apps/flashcards/FlashcardsMain")
);
const TestMain = loader.lazy(() => import("../apps/test/TestMain"));

// ErrorMain intentionally omitted from code splitting so that we can
// still route to errors even in the event of network disconnect

export default function MainSwitch() {
  const location = useLocation();

  return (
    <Switch>
      <Route
        path={READER_WITH_LOCATION}
        render={(routeProps) => (
          <ReaderMain key={routeProps.match.params.vbid} {...routeProps} />
        )}
      />
      <Route
        // combined path so we only do the tightrope init once even if you nav around
        path={[ENRICHMENT_STANDALONE, ENRICHMENT_PROGRESS]}
        component={EnrichmentMain}
      />
      <Route path={FLASHCARD_DECK} component={FlashcardsMain} exact />
      <Route path={DEV} component={DevMain} />
      <Route path={DEV_FEATURES} component={FeaturesMain} />
      <Route path={ERROR_BASE} component={ErrorMain} />
      <Route path={EMBED_WITH_PATH} component={EmbedMain} />
      <Route path={CRANE_EMBED} component={EmbedMain} />
      <Route path={TEST} component={TestMain} />
      {isLocalDev() && <Redirect to={DEV} from="/" exact />}
      <Redirect
        to={{
          pathname: ERROR_NOT_FOUND,
          state: { referrer: location.pathname },
        }}
      />
    </Switch>
  );
}
